export async function getFacturaAnticipo(id_presupuesto,tipo) {
    try{
        const res = await axios.get(`api/presupuesto/${id_presupuesto}/${tipo}/anticipo?not_taken=true`);
        return res.data;
    }catch(ex){
        
    }
}
export async function addFacturaAnticipoNegativa(lineas,id_presupuesto,tipo){

   const factura = await getFacturaAnticipo(id_presupuesto,tipo);
   console.log('addFacturaAnticipoNegativa',factura);
   if(factura){
    const exist = lineas.find(ele=>
        ele.id_factura_anticipo == factura.id
    ) != null;
    if(!exist){
        lineas.push({
            'id_tipo_dcto':1,
            'id_factura_anticipo':factura.id,
            'descripcion' :factura.lineas_rel[0].articulo,
            'articulo':null,
            'cantidad':1,
            'precio':-factura.lineas_rel[0].precio,
            'total':-factura.lineas_rel[0].precio,
            'dcto':0,
        });
    }
   }
}

